/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createReducer, createModuleAction } from 'redux-app/utils/reducer'

const createAction = createModuleAction('formUtil')
const sendDataToServerInProgress = createAction('SEND_DATA_TO_SERVER_IN_PROGRESS')
const sendDataToServerFinished = createAction('SEND_DATA_TO_SERVER_FINISHED')

export const onSendDataToServer = () => dispatch => {
  return dispatch(sendDataToServerInProgress())
}

export const onFinishSendDataToServer = () => dispatch => {
  return dispatch(sendDataToServerFinished())
}

const ACTION_HANDLERS = {
  [sendDataToServerInProgress.toString()]: state => ({
    ...state,
    isSendingInProgress: true,
  }),
  [sendDataToServerFinished.toString()]: state => ({
    ...state,
    isSendingInProgress: false,
  }),
}

const initialState = {
  isSendingInProgress: false,
}

export default createReducer(initialState, ACTION_HANDLERS)
